/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_documents = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.save = function(
		_pdf_file
	) {

		var _measuredocument_id = $('.js-measuredocument-id').val();

		var _url = globalUrl + '/a/a/project-measuredocument-pdf-save';

		/*
		Ajax: Save
		*/
		$.ajax({
			url: _url,
			type: "POST",
			data: {
				_measuredocument_id : _measuredocument_id,
				_pdf_file			: _pdf_file
			},
			headers: { 
				'go-load':1
			}
		})
		.done(function(data) {
		})
		.always(function() {
		});

	};

	this.delete = function(	
	) {

		var _measuredocument_id = $('.js-measuredocument-id').val();

		var _url = globalUrl + '/a/a/project-measuredocument-pdf-delete';

		/*
		Ajax: Save
		*/
		$.ajax({
			url: _url,
			type: "POST",
			data: {
				_measuredocument_id	: _measuredocument_id,
			},
			headers: { 
				'go-load':1
			}
		})
		.done(function(data) {
		})
		.always(function() {
		});

	};
		
}).apply(specific_documents); 